import React, { useState, useEffect } from 'react';
import ProfileBanner from './ProfileBanner';
import ProfileFeed from './ProfileFeed';
import axios from 'axios';
import WaiverModal from '../league/WaiverModal';
// import ProfileSidebarRight from './ProfileSidebarRight';

function ProfilePage() {
  const [activeLeague, setActiveLeague] = useState(null);
  const [activeSeason, setActiveSeason] = useState(null);
  const [user, setUser] = useState(null);
  const [showWaiverModal, setShowWaiverModal] = useState(false);

  useEffect(() => {
    // Fetch user data
    axios.get('/api/users/my-details/', {
      withCredentials: true,
    })
      .then(response => {
        setUser(response.data);
      })
      .catch(error => {
        console.error('Error fetching user data:', error);
      });

    async function checkWaiverStatus() {
      try {
        const seasonId = 1; // Replace with actual logic to get the season ID
        const waiverRes = await fetch(`/api/leagues/check-waiver-status/${seasonId}/`, { credentials: 'include' });
        const waiverData = await waiverRes.json();
        if (waiverData.waiver_required) {
          setShowWaiverModal(true);
        }
      } catch (err) {
        console.error('Error checking waiver status:', err);
      }
    }
    checkWaiverStatus();
  }, []);

  return (
    <>
      <WaiverModal show={showWaiverModal} onAgreed={() => setShowWaiverModal(false)} />
      {/* Banner row */}
      <div className="row">
        <ProfileBanner
          activeLeague={activeLeague}
          setActiveLeague={setActiveLeague}
          activeSeason={activeSeason}
          setActiveSeason={setActiveSeason}
        />
      </div>

      {/* Feed row */}
      <div className="row mt-3">
        <ProfileFeed
          user={user}
          activeLeague={activeLeague}
          activeSeason={activeSeason}
        />
        {/* <ProfileSidebarRight /> */}
      </div>
    </>
  );
}

export default ProfilePage;
